export const PaymentErrorCode = {
  LIABILITY_NOT_SHIFTED: 'LIABILITY_NOT_SHIFTED'
} as const;

export type PaymentErrorCode = typeof PaymentErrorCode[keyof typeof PaymentErrorCode];
